export const getErrorCode = () => Math.random().toString().substring(2, 6);
